import React, { useCallback } from "react";

import RellevateMenu from "../components/Menu";
import Footer from "../components/Footer";
import Home from "./Home";

import { Route, Routes } from "react-router-dom";
import QueryAssignedPaycards from "./QueryAssignedPaycards";
import QueryAvailablePaycards from "./QueryAvailablePaycards";

import AssignPaycard from "./AssignPaycard";
import { CssBaseline } from "@mui/material";
import { Box } from "@mui/system";
import Locations from "./Locations";
import Bundles from "./Bundles";
import QueryPayments from "./QueryPayments";
import ManageBalance from "./ManageBalance";
import QueryBalance from "./QueryBalance";
import QueryPendingPayments from "./QueryPendingPayments";
import QueryTimeAttendance from "./QueryTimeAttendance";
import QueryMembers from "./QueryMembers";
import QueryMissingTimeAttendance from "./QueryMissingTimeAttendance";
import UploadCipFile from "./UploadCipFile";
import UploadFile from "./UploadFile";
import Onboardings from "./Onboardings";
import QueryPaymentsSummary from "./QueryPaymentsSummary";
import UploadEwaCollectionAttempts from "./UploadEwaCollectionAttempts";
import StartedOnboardings from "./StartedOnboardings";
import EmployerAttributesConfig from "./EmployerAttributesConfig";
import PaymentDescriptorsConfig from "./PaymentDescriptorsConfig";
import SpendRulesConfig from "./SpendRulesConfig";
import AdministrativeFeesConfig from "./AdministrativeFeesConfig";
import LookupTableConfig from "./LookupTableConfig";
import ManageGroups from "./ManageGroups";
import ManageOrganizationalUnit from "./organizationalunit/ManageOrganizationalUnit";
import CampaingsConfig from "./CampaignsConfig";
import BulkOnboarding from "./BulkOnboarding";
import DashboardLocations from "./DashboardLocations";
import QueryMultiBalance from "./QueryMultiBalance";
import QueryCompanyMembers from "./QueryCompanyMembers";
import ManageWhitelist from "./ManageWhitelist";
import StartedOnboardingsRds from "./StartedOnboardingsRds";
import FlashReports from "./FlashReports";
import CardsDashboard from "./reports/CardsDashboard";
import EmployerConfig from "./employer/EmployerConfig";
import BulkPreauthorizeStandalone from "./BulkPreauthorizeStandAlone";
import PayrollDeductionsStandAlone from "./PayrollDeductionsStandAlone";
import KnowledgeBase from "./KnowledgeBase";
import InterCompanyTransfer from "./InterCompanyTransfer";
import QueryTransfers from "./QueryTransfers";
import { useChosenEmployer } from "../contexts/EmployerContext";
import QueryMultiBalancev2 from "./MultiBalance/QueryMultiBalancev2";
import Dashboard from "./Dashboard";
import RenderOnRole from "../components/RenderOnRole";

import UsersManagement from "./UsersManagement";
import Approvals from "./Approvals";
import ProofOfFunds from "./ProofOfFunds";
import SupportChatDashboard from "./crm/SupportChatDashboard";
import SupportChatConversation from "./crm/SupportChatConversation";
import SupportChatAllConversations from "./crm/SupportChatAllConversations";
import SchedulerTemplates from "./scheduler/SchedulerTemplates";
import SchedulerTemplateDetail from "./scheduler/SchedulerTemplateDetail";
import SchedulerCampaigns from "./scheduler/SchedulerCampaigns";
import SchedulerInstances from "./scheduler/SchedulerInstances";
import NotificationTemplateList from "./communication/NotificationTemplateList";
import NotificationTemplateEditor from "./communication/NotificationTemplateEditor";
import CardInventoryTransition, {
  INVENTORY_TRANSITION_CONFIGS,
} from "./CardInventoryTransition";
import CardInventoryOperations from "./CardInventoryOperations";
import GuardLockerManager from "./GuardLockerManager";

export default function MainSite() {
  const {
    employerData,
    chosenEmployerId,
    hasMultipleEmployers,
    onSwitchEmployer,
  } = useChosenEmployer();
  const [backgroundImg, setBackgroundImg] = React.useState(null);

  const getInitials = useCallback(async (subdomain) => {
    try {
      const extension = subdomain ? `.${subdomain}` : "";
      const backgroundImg = await import(
        `../images/Orange-to-green-background${extension}.png`
      );
      setBackgroundImg(backgroundImg.default);
    } catch (error) {
      console.error(error);
      getInitials("");
    }
  }, []);

  React.useEffect(() => {
    getInitials(window.subdomain);
  }, [getInitials]);

  return (
    <>
      <Box
        overflow="auto"
        height="100vh"
        flexDirection="column"
        display="flex"
        sx={{
          backgroundImage: backgroundImg ? `url(${backgroundImg})` : "none",
          backgroundPosition: "top center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <CssBaseline />
        <Box>
          <RellevateMenu
            employerData={employerData}
            chosenEmployerId={chosenEmployerId}
            hasMultipleEmployers={hasMultipleEmployers}
            onSwitchEmployer={onSwitchEmployer}
          />
        </Box>
        <Box
          overflow="auto"
          flex={1}
          flexDirection="column"
          display="flex"
          p={2}
        >
          <Routes>
            {/* PayCard*/}
            <Route
              exact
              path="/"
              element={
                <RenderOnRole roles={["home-dashboard", "ou-manager"]}>
                  <Dashboard />
                </RenderOnRole>
              }
            />
            <Route exact path="/assignCard" element={<AssignPaycard />} />
            <Route
              exact
              path="/assignCard/:bundleDetailId"
              element={<AssignPaycard />}
            />
            <Route
              exact
              path="/assignCardOnTheFly"
              element={<AssignPaycard onTheFly />}
            />
            <Route
              exact
              path="/queryAssignedPaycards"
              element={
                <QueryAssignedPaycards
                  employerIdentifier={employerData?.idEmployer}
                />
              }
            />
            <Route
              exact
              path="/queryAvailablePaycards"
              element={<QueryAvailablePaycards />}
            />
            <Route
              exact
              path="/cardInventory/reception"
              element={
                <CardInventoryTransition
                  transitionConfig={INVENTORY_TRANSITION_CONFIGS.reception}
                />
              }
            />
            <Route
              exact
              path="/cardInventory/assign-enablement"
              element={
                <CardInventoryTransition
                  transitionConfig={
                    INVENTORY_TRANSITION_CONFIGS.assignEnablement
                  }
                />
              }
            />
            <Route
              path="/cardInventory/operations"
              element={<CardInventoryOperations />}
            />
            <Route
              exact
              path="/requestPaycards"
              element={
                <Bundles employerIdentifier={employerData?.idEmployer} />
              }
            />
            <Route exact path="/locations" element={<Locations />} />
            <Route
              exact
              path="/dashboardLocations"
              element={<DashboardLocations />}
            />
            <Route exact path="/cip" element={<UploadCipFile />} />
            <Route
              exact
              path="/ewa/collectionAttempts"
              element={<UploadEwaCollectionAttempts />}
            />
            <Route exact path="/uploadFile" element={<UploadFile />} />
            {/* Payfile*/}
            <Route exact path="/manageBalance" element={<ManageBalance />} />
            <Route exact path="/balance" element={<QueryBalance />} />
            <Route
              exact
              path="/multiBalance"
              element={<QueryMultiBalancev2 />}
            />
            <Route exact path="/transfers" element={<InterCompanyTransfer />} />
            <Route exact path="/viewTransfers" element={<QueryTransfers />} />
            <Route
              exact
              path="/payments/summary"
              element={
                <QueryPaymentsSummary
                  employerIdentifier={employerData?.idEmployer}
                />
              }
            />
            <Route exact path="/payments" element={<QueryPayments />} />
            <Route
              exact
              path="/pendingPayments"
              element={<QueryPendingPayments />}
            />
            <Route exact path="/whitelist" element={<ManageWhitelist />} />
            {/* PayAnyDay*/}
            <Route
              exact
              path="/timeAttendance"
              element={<QueryTimeAttendance />}
            />
            <Route
              exact
              path="/companyMembers"
              element={<QueryCompanyMembers />}
            />
            <Route
              exact
              path="/pad/deduction"
              element={<PayrollDeductionsStandAlone />}
            />
            <Route exact path="/members" element={<QueryMembers />} />
            <Route
              exact
              path="/timeAttendance/missing"
              element={<QueryMissingTimeAttendance />}
            />
            {/* Onboarding*/}
            <Route exact path="/onboardings" element={<Onboardings />} />
            <Route
              exact
              path="/onboardings/started"
              element={<StartedOnboardings />}
            />
            <Route
              exact
              path="/onboardings/started/rds"
              element={<StartedOnboardingsRds />}
            />
            <Route
              exact
              path="/onboardings/bulk"
              element={<BulkOnboarding />}
            />
            <Route
              exact
              path="/onboardings/preauthorizeStandalone"
              element={<BulkPreauthorizeStandalone />}
            />
            <Route
              exact
              path="/guardlocker"
              element={
                <RenderOnRole roles={["guardlocker-manager"]}>
                  <GuardLockerManager />
                </RenderOnRole>
              }
            />
            {/* Configure*/}
            <Route exact path="/employer" element={<EmployerConfig />} />
            <Route
              exact
              path="/employerAttr"
              element={<EmployerAttributesConfig />}
            />
            <Route
              exact
              path="/paymentDescriptors"
              element={<PaymentDescriptorsConfig />}
            />
            <Route exact path="/spendRules" element={<SpendRulesConfig />} />
            <Route exact path="/lookup" element={<LookupTableConfig />} />
            <Route
              exact
              path="/administrativeFeesConfig"
              element={<AdministrativeFeesConfig />}
            />
            <Route exact path="/knowledgeBase" element={<KnowledgeBase />} />
            <Route
              exact
              path="/campaignsConfig"
              element={<CampaingsConfig />}
            />
            <Route exact path="/flashReports" element={<FlashReports />} />
            <Route exact path="/cardsDashboard" element={<CardsDashboard />} />
            {/* Groups*/}
            <Route exact path="/manageGroup" element={<ManageGroups />} />
            <Route
              exact
              path="/manageOrganizationalUnit"
              element={<ManageOrganizationalUnit />}
            />
            {/* Users */}
            <Route exact path="/users" element={<UsersManagement />} />
            <Route exact path="/approvals" element={<Approvals />} />
            <Route
              exact
              path="/proofOfFunds"
              element={
                <RenderOnRole roles={["compliance-mgr"]}>
                  <ProofOfFunds />
                </RenderOnRole>
              }
            />
            {/* Support Chat */}
            <Route
              exact
              path="/supportChat"
              element={
                <RenderOnRole roles={["chat-support"]}>
                  <SupportChatDashboard />
                </RenderOnRole>
              }
            />
            <Route
              exact
              path="/supportChat/all"
              element={
                <RenderOnRole roles={["chat-support"]}>
                  <SupportChatAllConversations />
                </RenderOnRole>
              }
            />
            <Route
              exact
              path="/supportChat/:conversationId"
              element={
                <RenderOnRole roles={["chat-support"]}>
                  <SupportChatConversation />
                </RenderOnRole>
              }
            />
            {/* Scheduler */}
            <Route
              exact
              path="/communication/scheduler/templates"
              element={
                <RenderOnRole
                  roles={["scheduler-admin", "pc-program-super-admin"]}
                >
                  <SchedulerTemplates />
                </RenderOnRole>
              }
            />
            <Route
              exact
              path="/communication/scheduler/templates/:id"
              element={
                <RenderOnRole
                  roles={["scheduler-admin", "pc-program-super-admin"]}
                >
                  <SchedulerTemplateDetail />
                </RenderOnRole>
              }
            />
            <Route
              exact
              path="/communication/scheduler/campaigns"
              element={
                <RenderOnRole
                  roles={["scheduler-admin", "pc-program-super-admin"]}
                >
                  <SchedulerCampaigns />
                </RenderOnRole>
              }
            />
            <Route
              exact
              path="/communication/scheduler/instances"
              element={
                <RenderOnRole
                  roles={["scheduler-admin", "pc-program-super-admin"]}
                >
                  <SchedulerInstances />
                </RenderOnRole>
              }
            />
            {/* Notification Templates */}
            <Route
              exact
              path="/communication/notification-templates"
              element={
                <RenderOnRole roles={["pc-program-super-admin"]}>
                  <NotificationTemplateList />
                </RenderOnRole>
              }
            />
            <Route
              exact
              path="/communication/notification-templates/:id"
              element={
                <RenderOnRole roles={["pc-program-super-admin"]}>
                  <NotificationTemplateEditor />
                </RenderOnRole>
              }
            />
            <Route exact path="*" element={<div>Under construction...</div>} />
          </Routes>
        </Box>
        <Box p={2.3}>
          <Footer />
        </Box>
      </Box>
    </>
  );
}
